// extracted by mini-css-extract-plugin
export default {"container":"miUPTlg15l6eAIkGNivB"};